import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import Typography from "../../base-components/Typography";
import { ReactComponent as Arrow } from "../../assets/icons/arrow-left.svg";

interface PageHeaderProps {
  title: string;
  backTo?: string;
  showBack?: boolean;
  className?: string;
}

// Consistent back-navigation + title, used across every wizard step so users
// always have a visible, predictable way back (previously ad-hoc: some pages
// had a back arrow, some had none, forcing reliance on the device back
// gesture).
const PageHeader = ({
  title,
  backTo,
  showBack = true,
  className,
}: PageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className={twMerge(["flex items-center space-x-4 mb-2", className])}>
      {showBack && (
        <button
          type="button"
          aria-label="Буцах"
          onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full outline-none transition-[background-color,box-shadow,transform] duration-150 ease-out [&:hover]:bg-primary-soft focus-visible:bg-primary-soft focus-visible:shadow-focus [&:active]:scale-90"
        >
          <Arrow className="h-[18px] w-[18px]" />
        </button>
      )}
      <Typography variant="Title" size="md">
        {title}
      </Typography>
    </header>
  );
};

export default PageHeader;
